<template>
  <div v-if="loader" class="global-loader">
    <Loader />
  </div>

  <div v-else>
    <div class="card">
      <div class="grid">
        <div class="col-12 lg:col-6">
          <h6 class="ml-2">Data Inserimento</h6>
          <Calendar
            v-model="selectedDates"
            selectionMode="range"
            :showIcon="true"
            dateFormat="dd-mm-yy"
            class="inputfield w-full mt-2"
          />
          <div v-show="validationErrors.dates && submitted" class="p-error">
            Seleziona campo.e
          </div>
        </div>
        <div class="col-12 lg:col-6 flex align-items-end justify-content-end" style="justify-content: flex-end;">
          <Button
            label="Cerca"
            @click="searchData"
            icon="pi pi-search"
            iconPos="left"
          />
        </div>
      </div>
    </div>

    <div v-if="selectedItems.some((el) => !regex_email.test(el.email))">
      <Message severity="warn" :closable="true">
        Alcuni clienti selezionati non hanno indirizzo email o hanno formato
        errato
      </Message>
    </div>

    <div v-if="selectedItems.some((el) => el.totale_fattura - el.pagato == 0)">
      <Message severity="error" :closable="true">
        Alcuni clienti selezionati hanno saldato la fattura
      </Message>
    </div>

    <!-- <div v-show="selectedItems.length > 0" class="btn-selected mb-2">
      <Button
        @click="sendEmailStorniRidPayments"
        class="p-button-warning p-3 m-1"
        style="min-width: 200px"
      >
        <div>
          Invia email selezionati ({{ selectedItems.length }})<br />
          <p style="font-size: 9px">
            L'invio è raggruppato per email ({{ n_grouped_email }})
          </p>
        </div>
        <i class="pi pi-send ml-5"></i>
      </Button>
    </div> -->

    <div v-if="Object.keys(originalItems).length != 0">
      <div class="card">
        <div class="grid">
          <div class="col-12 lg:col-6">
            <InputText
              @keyup="onGlobalSearch"
              class="mb-5 w-full"
              v-model="searchString"
              type="text"
              placeholder="Cerca..."
            />
          </div>
        </div>
        <Accordion lazy multiple>
          <AccordionTab v-for="(els, agentName) in items" :key="`${agentName}`">
            <template #header>
              <div class="flex justify-content-between flex-wrap w-full">
                <div class="flex align-items-center flex-column">
                  <div>
                    <div class="text-500 text-xs">
                      Agente <br />
                      <span class="text-800">{{
                        agentName.toUpperCase()
                      }}</span>
                    </div>
                  </div>
                </div>
                <i></i>
                <div class="text-left">
                  <div>
                    <small class="text-500 text-xs"
                      >{{ els.length }} storn{{
                        els.length > 1 ? "i" : "o"
                      }}</small
                    >
                    <br />
                    <span style="font-size: 12px">{{
                      formatCurrency(
                        els.reduce((acc, curr) => acc + curr.value, 0)
                      )
                    }}</span>
                  </div>
                </div>
              </div>
            </template>

            <DataTable
              :ref="`dt_storni_${agentName}`"
              :value="els"
              dataKey="numero"
              v-model:selection="selectedItems"
              responsiveLayout="scroll"
              :rowClass="rowClass"
              :exportFilename="`storni_${agentName}`"
              csvSeparator=";"
            >
              <template #header>
                <div class="flex justify-content-between flex-wrap">
                  <div class="flex">
                    <Button
                      icon="pi pi-external-link"
                      label="Esporta"
                      @click="exportCSV(agentName)"
                      class="p-button-secondary"
                    />
                    <Button
                      icon="pi pi-file-excel"
                      label="Esporta in Excel"
                      @click="exportExcel(agentName)"
                      class="p-button-success ml-2"
                    />
                    <Button
                      icon="pi pi-file-pdf"
                      label="Esporta in PDF"
                      @click="exportPDF(agentName)"
                      class="p-button-danger ml-2"
                    />
                  </div>
                  <div class="flex ml-auto">
                    <Button
                      label="Salva Motivazioni"
                      icon="pi pi-check"
                      @click="saveMotivazioni"
                      class="p-button-primary ml-5"
                    />
                    <!-- <Button
                      :label="`Invia email ad agenti (${selectedItems.length})`"
                      icon="pi pi-envelope"
                      @click="sendEmailToAgents"
                      class="p-button-success ml-5"
                    /> -->
                  </div>
                </div>
              </template>
              <template #empty>
                <div class="text-center">Nessun dato trovato.</div>
              </template>
              <Column selectionMode="multiple" headerStyle="width: 3rem" />
              <Column
                field="data_invio"
                header="Inviato"
                :sortable="true"
                style="min-width: 120px"
              >
                <template #body="{ data }">
                  {{
                    data.data_invio
                      ? moment(data.data_invio).format("DD-MM-YYYY")
                      : ""
                  }}
                </template>
              </Column>
              <Column
                field="data_ricezione"
                header="Data Ricezione"
                :sortable="true"
              ></Column>
              <Column
                field="data_notifica"
                header="Data Notifica"
                :sortable="true"
              ></Column>
              <Column field="numero" header="Fattura" :sortable="true"></Column>
              <Column field="pdp" header="Fornitura" :sortable="true"></Column>
              <Column
                field="cliente"
                header="Cliente"
                :sortable="true"
              ></Column>
              <Column field="email" header="Email" :sortable="true"></Column>
              <Column field="agente" header="Agente" :sortable="true"></Column>
              <Column
                field="agente_firmatario"
                header="Agente Firmatario"
                :sortable="true"
              ></Column>
              <Column header="Point" :sortable="true">
                <template #body="{ data }">
                  {{ Boolean(data.is_point) ? "Si" : "No" }}
                </template>
              </Column>
              <Column
                field="rappresentante"
                header="Rappresentante"
                :sortable="true"
              ></Column>
              <Column field="value" header="Importo" :sortable="true">
                <template #body="{ data }">
                  {{ formatCurrency(data.value) }}
                </template>
              </Column>
              <Column field="pagato" header="Pagato" :sortable="true">
                <template #body="{ data }">
                  {{ formatCurrency(data.pagato) }}
                </template>
              </Column>
              <Column
                field="dataNotificatoCliente"
                header="Data Invio Cliente"
                :sortable="true"
              ></Column>
              <Column
                field="dataNotificatoAgente"
                header="Data Invio Agente"
                :sortable="true"
              ></Column>
              <Column field="motivazione" header="Motivazione" :sortable="true">
                <template #body="{ data }">
                  <template v-if="data.note && data.note.toLowerCase().includes('rifiutata')">
                    {{ data.note }}
                  </template>
                  <Dropdown
                    v-else
                    v-model="data.motivazione"
                    :options="motivazioneOptions"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Seleziona motivazione"
                    class="w-full"
                  />
                </template>
              </Column>
            </DataTable>
          </AccordionTab>
        </Accordion>
      </div>
    </div>

    <!-- <div class="card mt-4">
      <div class="grid">
        <div class="col-6">
          <Button label="MPS" class="p-button-success w-full" @click="showUploadDialog('MPS')" />
        </div>
        <div class="col-6">
          <Button label="BPM" class="p-button-info w-full" @click="showUploadDialog('BPM')" />
        </div>
      </div>
    </div> -->

    <Dialog
      v-model:visible="uploadDialogVisible"
      :modal="true"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '30vw' }"
    >
      <template #header>
        <div class="flex justify-content-between align-items-center w-full">
          <h4>Caricamento file {{ uploadType }}</h4>
        </div>
      </template>
      <div class="p-fluid">
        <div class="field">
          <label for="fileUpload" class="mr-1">Seleziona file</label>
          <input
            type="file"
            id="fileUpload"
            @change="onFileSelected"
            accept=".zip"
          />
        </div>
        <div class="field mt-4">
          <Button label="Conferma" icon="pi pi-check" @click="uploadFile" />
          <Button
            label="Annulla"
            icon="pi pi-times"
            class="p-button-text"
            @click="uploadDialogVisible = false"
          />
        </div>
        <div v-if="previewAvailable" class="field mt-4">
          <Button
            label="Visualizza Preview"
            icon="pi pi-eye"
            @click="viewPreview"
          />
        </div>
      </div>
    </Dialog>

    <Dialog
      modal
      header="Controllo Invii"
      v-model:visible="dialogEmailSent"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '70vw' }"
    >
      <div class="w-full">
        <DataTable :value="report" responsiveLayout="scroll">
          <Column field="email" header="Email" :sortable="true"></Column>
          <Column field="success" header="Inviata" :sortable="true">
            <template #body="{ data, field }">
              <span v-if="data[field] == true" class="text-green-400">SI</span>
              <span v-else class="text-orange-400">NO</span>
            </template>
          </Column>
          <Column field="msg" header="Errore" :sortable="true"></Column>
          <Column field="invoices" header="Invii" :sortable="true">
            <template #body="{ data, field }">
              <span>{{ data[field].length }}</span>
            </template>
          </Column>
        </DataTable>
      </div>
      <template #footer>
        <Button
          label="Chiudi"
          icon="pi pi-times"
          @click="dialogEmailSent = false"
          class="p-button-text"
        />
      </template>
    </Dialog>

    <Dialog
      modal
      header="Preview dei file"
      v-model:visible="previewDialogVisible"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '50vw' }"
    >
      <div class="w-full">
        <div class="flex justify-content-between align-items-center mb-2">
          <h6>Total Records: {{ previewData.length }}</h6>
        </div>
        <DataTable :value="previewData" responsiveLayout="scroll">
          <Column field="numero" header="Numero" :sortable="true"></Column>
          <Column field="importo" header="Importo" :sortable="true"></Column>
          <Column field="data" header="Data" :sortable="true"></Column>
        </DataTable>
      </div>
      <template #footer>
        <Button
          label="Chiudi"
          icon="pi pi-times"
          @click="previewDialogVisible = false"
          class="p-button-text"
        />
        <Button
          label="Invia"
          icon="pi pi-send"
          @click="processInvoices"
          class="p-button-primary"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import moment from "moment";
import PraticheService from "@/services/ask-pratiche/pratiche-service";
import { ref, onMounted, getCurrentInstance, watch, computed } from "vue";
import { FilterMatchMode } from "primevue/api";
import Loader from "@/components/Loader.vue";
import { useToast } from "primevue/usetoast";
import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import "jspdf-autotable";

export default {
  components: {
    Loader,
  },
  setup() {
    const dt = ref();
    const regex_email =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\].[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const toast = useToast();
    const filters = ref({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    self.$http = self.appContext.config.globalProperties.$http;
    const service = new PraticheService(self.$http, self.$eventBus);
    const formatDate = self.appContext.config.globalProperties.$formatDate;
    const loader = ref(false);
    const items = ref([]);
    const originalItems = ref([]);
    const report = ref({});
    const dialogEmailSent = ref(false);
    const agents = ref([]);
    const selectedAgents = ref([]);
    const selectedItems = ref([]);
    const selectedDates = ref([new Date()]);
    const searchString = ref("");
    const validationErrors = ref({});
    const submitted = ref(false);
    const uploadDialogVisible = ref(false);
    const selectedFile = ref(null);
    const selectedFileName = ref("");
    const uploadType = ref("");
    const previewAvailable = ref(false);
    const previewDialogVisible = ref(false);
    const previewData = ref([]);

    onMounted(() => {
      searchData();
    });

    const searchData = () => {
      submitted.value = true;
      if (validateInputs()) {
        report.value = [];
        loader.value = true;
        items.value = [];
        let dates = [];
        if (selectedDates.value[0]) {
          dates[0] = moment(selectedDates.value[0]).format("YYYY-MM-DD");
          dates[1] = moment(selectedDates.value[0]).format("YYYY-MM-DD");
        }
        if (selectedDates.value[1]) {
          dates[1] = moment(selectedDates.value[1]).format("YYYY-MM-DD");
        }

        service
          .getStorniRidPayments(dates)
          .then((res) => {
            items.value = res.items;
            originalItems.value = res.items;
            for (const name of Object.keys(res.items)) {
              agents.value.push({ name: name });
            }
          })
          .finally(() => {
            loader.value = false;
          });
      }
    };

    const showUploadDialog = (type) => {
      uploadType.value = type;
      uploadDialogVisible.value = true;
      selectedFile.value = null;
      selectedFileName.value = "";
      previewAvailable.value = false;
    };

    const onFileSelected = (event) => {
      const file = event.target.files[0];
      if (file) {
        selectedFile.value = file;
        selectedFileName.value = file.name;
      } else {
        selectedFile.value = null;
        selectedFileName.value = "";
      }
    };

    const uploadFile = async () => {
      loader.value = true;
      if (selectedFile.value) {
        const formData = new FormData();
        formData.append("file", selectedFile.value);
        formData.append("type", uploadType.value);

        try {
          const response = await service.UploadZipMpsOrBPM(formData);
          if (response && response.status === 200) {
            toast.add({
              severity: "success",
              summary: "Successo",
              detail: "File caricato con successo: " + response.data.filename,
            });
            previewAvailable.value = true;
          } else {
            toast.add({
              severity: "error",
              summary: "Errore",
              detail: "Caricamento file fallito",
            });
          }
        } catch (error) {
          toast.add({
            severity: "error",
            summary: "Errore",
            detail: "Si è verificato un errore durante il caricamento del file",
          });
        } finally {
          loader.value = false;
        }
      } else {
        loader.value = false;
        toast.add({
          severity: "warn",
          summary: "Attenzione",
          detail: "Seleziona un file prima di confermare",
        });
      }
    };

    const viewPreview = async () => {
      loader.value = true;
      try {
        const response = await service.getPreviewData({
          type: uploadType.value,
        });
        if (response && response.status === 200) {
          previewData.value = response.data.previewData || [];
          previewDialogVisible.value = true;
        } else {
          toast.add({
            severity: "error",
            summary: "Errore",
            detail: "Impossibile ottenere i dati di anteprima",
          });
        }
      } catch (error) {
        toast.add({
          severity: "error",
          summary: "Errore",
          detail:
            "Si è verificato un errore durante il recupero dei dati di anteprima",
        });
      } finally {
        loader.value = false;
      }
    };

    const processInvoices = async () => {
      loader.value = true;
      try {
        const response = await service.processInvoices(previewData.value);
        if (response && response.status === 200) {
          toast.add({
            severity: "success",
            summary: "Successo",
            detail: "Fatture processate con successo",
          });
          previewDialogVisible.value = false;
        } else {
          toast.add({
            severity: "error",
            summary: "Errore",
            detail: "Errore nel processare le fatture",
          });
        }
      } catch (error) {
        toast.add({
          severity: "error",
          summary: "Errore",
          detail:
            "Si è verificato un errore durante il processamento delle fatture",
        });
      } finally {
        loader.value = false;
      }
    };

    const totale_pagamenti = () => {
      let total = 0;
      items.value.forEach((el) => {
        total += el.value;
      });
      return formatCurrency(total);
    };

    const sendEmailStorniRidPayments = () => {
      if (selectedItems.value.every((el) => regex_email.test(el.email))) {
        loader.value = true;
        service
          .sendEmailStorniRidPayments(selectedItems.value)
          .then((res) => {
            dialogEmailSent.value = true;
            report.value = res.items;
          })
          .finally(() => {
            loader.value = false;
          });
      } else {
        toast.add({
          severity: "warn",
          summary: "Attenzione",
          detail: "Alcune email hanno formato non valido",
        });
      }
    };

    const rowClass = (data) => {
      return !regex_email.test(data.email) ? "bg-yellow-100" : "";
    };

    const onGlobalSearch = () => {
      let tempItems = JSON.parse(JSON.stringify(originalItems.value));
      searchString.value = searchString.value.toLowerCase();
      filters.value.global.value = searchString.value;

      if (searchString.value.length > 0 && Object.keys(tempItems).length > 0) {
        for (const name of Object.keys(tempItems)) {
          tempItems[name] = tempItems[name].filter(
            (el) =>
              el.numero.toLowerCase().includes(searchString.value) ||
              (el.agente &&
                el.agente.toLowerCase().includes(searchString.value)) ||
              (el.rappresentante &&
                el.rappresentante.toLowerCase().includes(searchString.value)) ||
              (el.cliente &&
                el.cliente.toLowerCase().includes(searchString.value)) ||
              (el.pdp && el.pdp.toLowerCase().includes(searchString.value))
          );
          if (tempItems[name].length == 0) {
            delete tempItems[name];
          }
        }
      }

      items.value = tempItems;
    };

    const validateInputs = () => {
      validationErrors.value = {};

      if (selectedDates.value == null) {
        validationErrors.value["dates"] = true;
      } else {
        delete validationErrors.value["dates"];
      }

      return !Object.keys(validationErrors.value).length;
    };

    const onCellEditComplete = (event) => {
      let { newValue, field, index } = event;
      items.value[index][field] = newValue;
    };

    watch(selectedAgents, (newItems) => {
      selectedItems.value = [];
      if (newItems.length == 0) {
        selectedItems.value = [];
      } else {
        newItems.forEach((n) => {
          let tempItems = originalItems.value[n];
          tempItems.forEach((e) => {
            selectedItems.value.push(e);
          });
        });
      }
    });

    const n_grouped_email = computed(() => {
      const n = selectedItems.value.reduce((acc, item) => {
        if (!acc[item.email]) {
          acc[item.email] = [];
        }
        acc[item.email].push(item);
        return acc;
      }, {});

      Object.keys(n).forEach((key) => {
        if (!key) {
          delete n[key];
        }
      });

      return Object.keys(n).length;
    });

    const formatCurrency = (value) => {
      return value.toLocaleString("it-IT", {
        style: "currency",
        currency: "EUR",
      });
    };

    const exportCSV = (agentName) => {
      self.refs[`dt_storni_${agentName}`].exportCSV();
    };

    watch(selectedItems, (newItems) => {
      console.log("Elementi selezionati:", newItems);
    });

    const saveMotivazioni = async () => {
      try {
        const motivazioniData = selectedItems.value.map((item) => {
          return {
            numero: item.numero,
            motivazione: item.note?.toLowerCase().includes('rifiutata') 
              ? item.note 
              : item.motivazione
          };
        });

        await service.updateMotivazioni(motivazioniData);

        selectedItems.value = [];

        toast.add({
          severity: "success",
          summary: "Successo",
          detail: "Motivazioni aggiornate con successo!",
        });
      } catch (err) {
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Errore durante l'aggiornamento delle motivazioni.",
        });
      }
    };

    const motivazioneOptions = ref([
      {
        label: "AC01 - Numero di conto errato",
        value: "AC01 - Numero di conto errato",
      },
      {
        label: "AC04 - Numero di conto chiuso",
        value: "AC04 - Numero di conto chiuso",
      },
      { label: "AC06 - Account bloccato", value: "AC06 - Account bloccato" },
      {
        label: "AC13 - Tipo di conto debitore non valido",
        value: "AC13 - Tipo di conto debitore non valido",
      },
      {
        label: "AG01 - Tipo di pagamento non consentito",
        value: "AG01 - Tipo di pagamento non consentito",
      },
      {
        label: "AG02 - Codice operativo bancario non valido",
        value: "AG02 - Codice operativo bancario non valido",
      },
      {
        label: "AM05 - Raccolta / registrazione duplicate",
        value: "AM05 - Raccolta / registrazione duplicate",
      },
      {
        label: "BE05 - Parte Iniziante Non Riconosciuta",
        value: "BE05 - Parte Iniziante Non Riconosciuta",
      },
      {
        label: "FF01 - Formato file non valido",
        value: "FF01 - Formato file non valido",
      },
      {
        label: "FF05 - Codice strumento locale non valido",
        value: "FF05 - Codice strumento locale non valido",
      },
      {
        label: "MD01 - Nessun mandato valido",
        value: "MD01 - Nessun mandato valido",
      },
      {
        label: "MD02 - Informativa obbligatoria mancante",
        value: "MD02 - Informativa obbligatoria mancante",
      },
      {
        label: "MD06 - Richiesta di rimborso da parte del cliente finale",
        value: "MD06 - Richiesta di rimborso da parte del cliente finale",
      },
      {
        label: "MD07 - Cliente finale deceduto",
        value: "MD07 - Cliente finale deceduto",
      },
      {
        label: "MS02 - Motivo non specificato dal cliente",
        value: "MS02 - Motivo non specificato dal cliente",
      },
      { label: "RC01 - BIC non valido", value: "RC01 - BIC non valido" },
      {
        label: "RR01-04 - Motivo normativo",
        value: "RR01-04 - Motivo normativo",
      },
      {
        label:
          "AM04 - DENARO DISPONIBILE PER COPRIRE L'IMPORTO DELLA TRANSAZIONE NON SUFFICIENTE",
        value:
          "AM04 - DENARO DISPONIBILE PER COPRIRE L'IMPORTO DELLA TRANSAZIONE NON SUFFICIENTE",
      },
    ]);

    const sendEmailToAgents = async () => {
      try {
        const agentData = selectedItems.value.map((item) => {
          return {
            agente: item.agente,
            email: item.email,
            numero: item.numero,
            motivazione: item.motivazione,
            value: item.value,
            pagato: item.pagato,
            cliente: item.cliente,
          };
        });


        await service.sendEmailToAgents(agentData);

        toast.add({
          severity: "success",
          summary: "Successo",
          detail: "Email inviate agli agenti con successo!",
        });
      } catch (err) {
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Errore durante l'invio delle email agli agenti.",
        });
      }
    };

    const exportPDF = async (agentName) => {
      const dtRef = self.refs[`dt_storni_${agentName}`];
      const data = dtRef.value || [];

      const payload = data.map((item) => ({
        numero: item.numero,
        pdp: item.pdp,
        cliente: item.cliente,
        email: item.email,
        agente: item.agente,
        agente_firmatario: item.agente_firmatario,
        rappresentante: item.rappresentante || "Non specificato",
        importo: item.value,
        pagato: item.pagato,
        motivazione: item.motivazione,
      }));



      
      try {
        const response = await service.generatePDFStorniRid(agentName, payload);

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `storni_${agentName}.pdf`;
        link.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Errore durante la generazione del PDF",
        });
      }
    };

    const exportExcel = (agentName) => {
      const dtRef = self.refs[`dt_storni_${agentName}`];
      const data = dtRef.value || [];

      const filteredData = data.map((item) => ({
        numero: item.numero,
        pdp: item.pdp,
        cliente: item.cliente,
        email: item.email,
        agente: item.agente,
        AgenziaMaster: item.agente_firmatario,
        rappresentante: item.rappresentante,
        importo: item.value,
        pagato: item.pagato,
        motivazione: item.motivazione,
      }));

      const worksheet = XLSX.utils.json_to_sheet(filteredData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, `Storni ${agentName}`);

      XLSX.writeFile(workbook, `storni_${agentName}.xlsx`);
    };

    return {
      dt,
      formatDate,
      regex_email,
      moment,
      items,
      originalItems,
      selectedItems,
      searchString,
      loader,
      agents,
      selectedAgents,
      report,
      filters,
      selectedDates,
      searchData,
      rowClass,
      totale_pagamenti,
      onCellEditComplete,
      sendEmailStorniRidPayments,
      formatCurrency,
      onGlobalSearch,
      dialogEmailSent,
      n_grouped_email,
      validationErrors,
      submitted,
      exportCSV,
      uploadDialogVisible,
      selectedFile,
      selectedFileName,
      uploadType,
      showUploadDialog,
      onFileSelected,
      uploadFile,
      previewAvailable,
      previewDialogVisible,
      previewData,
      viewPreview,
      processInvoices,
      motivazioneOptions,
      saveMotivazioni,
      sendEmailToAgents,
      exportExcel,
      exportPDF,
    };
  },
};
</script>

<style scoped>
.global-loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.btn-selected {
  position: fixed;
  bottom: 58px;
  right: 40px;
  z-index: 2;
}
.btn-selected-agent {
  position: fixed;
  bottom: 60px;
  right: 40px;
  z-index: 2;
}
.p-fluid .field {
  position: relative;
}
</style>

